import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../__legacy__/models/error.model';
import { IMainApiService, IPagedResult } from '../../../__legacy__/services/api.service';
import { IApiService } from '../../../__legacy__/services/api.service.base';
import { IApiServiceTraining } from '../../../__legacy__/services/api.service.training';

interface IGetWorkspacesRequest {
  pageNumber: number;
  pageSize: number;
  orderBy: string;
  orderType: string;
}

type IWorkspaceCostsDto = Record<
  string,
  {
    total_cost_actual: number;
    total_cost_calculated: number;
  }
>;

interface IWorkspaceDto {
  id: string;
  cloudCostsLimit: number;
  name: string;
  ownerCompany: string;
  ownerEmail: string;
}

interface IUpdateWorkspaceLimitRequest {
  workspaceId: string;
  cloudCostLimit: number;
}

export interface IAdminApiService {
  getWorkspacesAsync(request: IGetWorkspacesRequest): Promise<IPagedResult<IWorkspaceDto> | ACDLError>;
  getWorkspacesCostsAsync(request: string[]): Promise<IWorkspaceCostsDto | ACDLError>;
  updateWorkspaceLimitAsync(request: IUpdateWorkspaceLimitRequest): Promise<null | ACDLError>;
}

export namespace IAdminApiService {
  export const $: interfaces.ServiceIdentifier<IAdminApiService> = Symbol('ADMIN_API_SERVICE');
}

@injectable()
export class AdminApiService implements IAdminApiService {
  constructor(
    @inject(IMainApiService.$) private readonly apiService: IApiService,
    @inject(IApiServiceTraining.$) private readonly apiTrainingService: IApiService
  ) {}

  async getWorkspacesAsync(request: IGetWorkspacesRequest): Promise<IPagedResult<IWorkspaceDto> | ACDLError> {
    return await this.apiService.getAsync(`/Models/GetWorkspacesForAdminCostsTable`, { params: request });
  }

  async getWorkspacesCostsAsync(request: string[]): Promise<IWorkspaceCostsDto | ACDLError> {
    return await this.apiTrainingService.postAsync(`/workspaces/cost-usage/comparison`, request);
  }

  async updateWorkspaceLimitAsync(request: IUpdateWorkspaceLimitRequest): Promise<null | ACDLError> {
    return await this.apiService.postAsync(`/Workspace/UpdateCloudCostLimit`, request);
  }
}
